<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <!-- end col -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Users Checkers Queue</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <UsersCheckersQueueTable />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>

import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";

export default {
  page: {
    title: "Users Checkers Queue",
    meta: [{ name: "Users Checkers Queue", content: window.__env.app.description }]
  },
  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
      title: "Users Checkers Queue",
      items: [
        {
          text: "Users",
          href: "/"
        },
        {
          text: "Users Checkers Queue",
          active: true
        }
      ]
    };
  }
};
</script>
